"use strict";

import { userConstants } from "../_constants";

export const INITIAL_USER_STATE = {
    latestAchievements: {
        confirmedCount: 0,
        pendingCount: 0,
        achievements: [],
    },
    thingsToDo: [],
    memberships: [],
    pointsBalance: {
        totalPointsBalance: "",
        transactionsGroupsByDate: [],
    },
    userGoals: [],
    incentiveHistory: {
        lastActiveCampaigns: "",
        incentives: [],
    },

    participantNotificationCount: "",
    participantNotifications: [],
    newsFeed: [],
    points: 0,
    latestTransactions: [],
};

export function user(state = INITIAL_USER_STATE, action) {
    switch (action.type) {
        case userConstants.USER_GET_LATEST_ACHIEVEMENTS_COMPLETE:
            return {
                ...state,
                latestAchievements: { ...action.payload.data },
            };

        case userConstants.USER_GET_THINGS_TO_DO_COMPLETE:
            return {
                ...state,
                thingsToDo: [...action.payload.data.todoList],
            };
        case userConstants.USER_MEMBERSHIP_COMPLETE:
            return {
                ...state,
                memberships: [...action.payload.data],
            };

        case userConstants.USER_POINTS_TRANSACTIONS_COMPLETE:
            return {
                ...state,
                pointsBalance: { ...action.payload.data },
            };

        case userConstants.USER_GOALS_COMPLETE:
            return {
                ...state,
                userGoals: [...action.payload.data],
            };

        case userConstants.GET_PARTICIPANT_NOTIFICATION_COMPLETE:
            return {
                ...state,

                participantNotifications: [...action.payload.data],
                participantNotificationCount: [...action.payload.data].filter(
                    (notification) => !notification.isRead,
                ).length,
            };
        case userConstants.GET_NEWS_FEED_COMPLETE:
            return {
                ...state,
                newsFeed: [...action.payload.data],
            };

        case userConstants.USER_INCENTIVE_HISTORY_COMPLETE:
            return {
                ...state,
                incentiveHistory: {
                    incentives: [...action.payload.data],
                    lastActiveCampaigns: "",
                },
            };

        case userConstants.GET_USER_POINTS_BALANCE_COMPLETE:
            return {
                ...state,
                points: action.payload.data,
            };

        case userConstants.GET_LATEST_TRANSACTIONS_COMPLETE:
            return {
                ...state,
                latestTransactions: [...action.payload.data],
            };
    }

    return state;
}
